import { esusApi } from "@/services/api";

export type ResumeIndicatorC4Params = {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	ine?: string;
};

export class ResumeIndicatorC4Data {
	totalDiabeticCitizens: number = 0;
	totalDiabeticCitizensInPeriod: number = 0;
	totalDiabeticCitizensInPeriodScore: number = 0;
	maxDiabeticCitizensInPeriodScore: number = 0;
}

export async function getResumeIndicatorC4({ uf, ibgeCode, ...params }: ResumeIndicatorC4Params) {
	const response = await esusApi.get<ResumeIndicatorC4Data>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esf/c4/resume`,
		params
	);
	return response.data ?? new ResumeIndicatorC4Data();
}
